import { proxy } from 'valtio';
import { z } from 'zod';
import { authUserFilterQueryKey } from '@context/authHelpers';
import { graphqlClientHeaders } from '@context/headers';
import type { AuthUserQuery, ExecutionResultWithData } from '@graphql/reactQuery';
import { AuthUserDocument, setQueryData } from '@graphql/reactQuery';
import { PersistenceStorage } from '@store/persistence';

const persistedAuthSchema = z.custom<ExecutionResultWithData<AuthUserQuery>>();

export const authUserPersistenceStore = PersistenceStorage({
  schema: persistedAuthSchema,
  key: `auth-${AuthUserDocument}`,
});

export const persistedUserState = proxy({
  isLoading: false,
});

export function setAuthToken(token: string) {
  authUserPersistenceStore.clear();

  graphqlClientHeaders['auth-token'] = token;
  localStorage.setItem('auth-token', token);
}

export function removeAuthToken() {
  authUserPersistenceStore.clear();
  delete graphqlClientHeaders['auth-token'];
  localStorage.removeItem('auth-token');
}

if (typeof window !== 'undefined') {
  const authToken = graphqlClientHeaders['auth-token'];

  if (authToken) {
    persistedUserState.isLoading = true;

    authUserPersistenceStore.initialValue
      .then(persistedValue => {
        if (!persistedValue) return;

        setQueryData(
          {
            query: AuthUserDocument,
            filterQueryKey: authUserFilterQueryKey({
              authToken,
            }),
            options: {
              updatedAt: Date.now() - 1000,
            },
          },
          persistedValue,
        );
      })
      .finally(() => {
        persistedUserState.isLoading = false;
      });
  }
}
